import styled from 'styled-components'
import { device } from 'components/Variable'
import { rem } from 'utils/common'

export const ExchangeList = styled.div`
	margin-bottom: ${rem(50)};

	@media (${device.mobileL}) {
		margin-bottom: ${rem(70)};

		.react-select__menu {
			z-index: 2;
		}
	}

	@media (${device.mobileS}) {
		margin-bottom: ${rem(80)};

		.react-select__menu {
			z-index: 2;
		}
	}
`
